module.exports = __webpack_public_path__ + "img/texas-tech-seal.ec0d4ed2.png";